import React, { useEffect, useState } from "react";
import {
  Link,
  Navigate,
  replace,
  useMatch,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import "../../styles/Menubar/menubar.css";
import {
  ActiveAnalyseIcon,
  ActiveDashBoardIcon,
  ActiveGroundIcon,
  ActiveHomeIcon,
  ActiveMatchIcon,
  ActiveOfficialIcon,
  ActivePlayerIcon,
  ActiveStatsIcon,
  ActiveTeamIcon,
  ActiveTournamentIcon,
  AnalyseIcon,
  DashBoardIcon,
  GroundIcon,
  HomeIcon,
  MatchIcon,
  OfficialIcon,
  PlayerIcon,
  StatsIcon,
  TeamIcon,
  TournamentIcon,
  ProfileIcon,
} from "../../assets/SvgIcons";
import { getData, removeData } from "../../utils/localstorage_constants";
import { IS_ADMIN, IS_LOGGED } from "../../utils/localstorage_variables";
const Menubar = () => {
  const navigate = useNavigate();
  let [isloged, setIsLoged] = useState(false);
  let [isadmin, setIsAdmin] = useState(false);
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = () => {
    isloged = getData(IS_LOGGED);
    setIsLoged(isloged);

    isadmin = getData(IS_ADMIN);
    setIsAdmin(isadmin);
  };
  const handleLogout = () => {
    removeData();
    navigate("/login", { replace: true });
  };
  return (
    <nav className="navbar1">
      {isloged && (
        <div className="">
          <ul>
            <CustomLink
              to="/"
              name="Home"
              activeImage={ActiveHomeIcon}
              inactiveImage={HomeIcon}
            />
            {isadmin && (
              <CustomLink
                to="/users"
                name="Users"
                activeImage={ActivePlayerIcon}
                inactiveImage={PlayerIcon}
              />
            )}
          </ul>
        </div>
      )}
      <div>
        <button className="logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Menubar;

function CustomLink({
  to,
  children,
  activeImage,
  inactiveImage,
  name,
  ...props
}) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        <div className="icon_name_container">
          <img
            className="icon"
            src={isActive ? activeImage : inactiveImage}
            alt={isActive ? "Active Icon" : "Inactive Icon"}
          />
          <span className={isActive ? "icon_activename" : "icon_inactivename"}>
            {name}
          </span>
        </div>
        {children}
      </Link>
    </li>
  );
}
